import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Link, browserHistory } from "react-router";
import * as $ from "jquery";
import { Modal } from "react-bootstrap";
import { getStorage, setStorage, HTTP , getCarrierId , toastr, isNewModal, changeTheme} from "../../../services/Common.services";
import * as actionCreators from "./actionCreators";
import configuration from "../../../config";
import { LogoPortPro, LogoPortProSmall } from "../CustomIcons/Index";

import {
  asyncActionNames,
  buildAsyncActions,
} from "../../../Components/Common/GlobalActionCreators";
import config from "../../../config";
import {
  IconBilling,
  IconHeartRate,
  IconMonitor,
  IconPayment,
  IconSettings,
  IconSteering,
  IconTruckFront,
  IconUserAlt,
  IconUserBox,
  IconUsersGroup,
  SystemLogIcon,
} from "../Icons";
import { getChargeCodes } from "../../FetchData/actionCreators";
import noImage from "../../../assets/images/background/no-image.jpg"
import themesOptions from "../../../pages/tms/Profile/themeOptions";
import { getMainTheme } from "../../../pages/tms/Profile/actionCreators";
import LogoutButton from "../../Login/Auth0Logout";
import LearningMenu from "./LearningMenu";
const actionNames = asyncActionNames("LOGIN");
const ACTIONCREATORS = buildAsyncActions(actionNames);
const firebase = config.firebase;

class Sidebar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      userType: null,
      requests: 0,
      NoOfrequestedLoads: 0,
      addDriverModal: false,
      confirmDriverModal: false,
      selected: undefined,
      defaultDriver: null,
      currentUrl: "",
      commonUrl: null,
      isActive: false,
      user: JSON.parse(getStorage("loggedInUser")),
      carrier:JSON.parse(getStorage("carrierDetail")),
      themeSetting: JSON.parse(getStorage("themeSetting")),
      acl: null,
      customerType: [],
      carrierId: getCarrierId(),
      isMenuHovered: false,
      ismenuhoveredcheck: false, 
      isMenuClicked: null,
      isMenuOpen: false,
    };
    // this.handleMenuHover = this.handleMenuHover.bind(this);
    this.handleMenuEnter = this.handleMenuEnter.bind(this);
    this.handleMenuLeave = this.handleMenuLeave.bind(this);
    this.timer = null;

  }
  onTimeout = () => {
    this.setState(() => ({
      isMenuHovered: true,
    }));
  };

  clearTimer = () => {
    clearTimeout(this.timer);
  };

  handleMenuEnter = () => {
    this.setState({ ismenuhoveredcheck: true });
    this.timer = setTimeout(this.onTimeout, 300);
  }

  handleMenuLeave = () => {
    if(this.timer) {
      this.clearTimer();
    }
    this.setState(() => ({
      isMenuHovered: false,
      ismenuhoveredcheck: false,
      isMenuClicked:
        this.state.isMenuHovered && this.state.isMenuClicked
          ? null
          : this.state.isMenuClicked,
    }));
  } 

  handleMenuClick = (i) => {
    this.setState({
      isMenuClicked: this.state.isMenuClicked === i ? null : i,
    });
  };

  componentWillUpdate() {
    var self = this;
    browserHistory.listen((location) => {
      if (getStorage("loggedInUser")) {
        let user = JSON.parse(getStorage("loggedInUser"));
        self.setState({ user, acl: user.acl });
      } else {
        self.setState({ user: null, acl: null });
      }
    });
  }

  componentWillMount() {
    this.getUserDetails();
  }
  
  componentWillUnmount() {
    this.clearTimer();
  }

  getUserDetails = () => {
    let self = this;
    const userToken = getStorage("token");
    const user =
      getStorage("loggedInUser") && JSON.parse(getStorage("loggedInUser"));
    if (userToken && user) {
      self.setState({
        user,
        permissions: user.permissions,
        acl: user.acl,
        customerType: user.customer ? user.customer.customerType : [],
      });
      this.props.dispatch(ACTIONCREATORS.success(user));
    }
  };
  
  componentDidMount() {
    this.getThemeSettings()
    //Mouseover
 
    //#region shipper
    setTimeout(() => {
      if (!this.state.user) {
        const user = JSON.parse(getStorage("loggedInUser"));
        if (user)
          this.setState({
            user,
            acl: user.acl,
            customerType: user.customer ? user.customer.customerType : [],
          });
      }
    }, 3000);
    browserHistory.listen((location) => {
      this.sidebarRefresh();
    });

    this.sidebarRefresh();

    if (this.state.user && this.state.user.role === "shipper") {
      this.props.actions.requested
        .getRequestedCarrier()
        .then((res) => {
          if (typeof res.requestedCarriers[0] !== "undefined") {
            localStorage.setItem(
              "requests",
              res.requestedCarriers[0].notifyBy.length
            );
            this.setState({
              requests: res.requestedCarriers[0].notifyBy.length,
            });
          }
        })
        .catch((s) => {});
    }
    if (getStorage("loggedInUser") != null) {
      const currentUser = JSON.parse(getStorage("loggedInUser"));
     
      if(['carrier','customer','fleetmanager'].includes(currentUser.role)){
        let carrierID;
        if(currentUser.role == 'carrier'){
          carrierID = currentUser._id
        }
        if(currentUser.role == 'customer'){
          carrierID = currentUser.customer.carrier
        }
        if(currentUser.role == 'fleetmanager'){
          carrierID = currentUser.fleetManager.carrier
        }
        this.updatedChargecodeRef = firebase
          .database()
          .ref(`${carrierID}/updateChargeCode`);
          this.updatedChargecodeRef.on("value", (snapshot) => {
            this.props.getChargeCodes()
          })
      }
     
      if(['carrier','customer','fleetmanager'].includes(currentUser.role)){
        let carrierID;
        if(currentUser.role == 'carrier'){
          carrierID = currentUser._id
        }
        if(currentUser.role == 'customer'){
          carrierID = currentUser.customer.carrier
        }
        if(currentUser.role == 'fleetmanager'){
          carrierID = currentUser.fleetManager.carrier
        }
        this.updatedChargecodeRef = firebase
          .database()
          .ref(`${carrierID}/updateChargeCode`);
          this.updatedChargecodeRef.on("value", (snapshot) => {
            this.props.getChargeCodes()
          })
      }
    }
  }

  sidebarRefresh() {
    const self = this;
    const url = window.location + "";
    const path = url.replace(
      window.location.protocol + "//" + window.location.host + "/",
      ""
    );

    const element = $("ul#sidebarnav a").filter(function () {
      if (this.href.indexOf("customer-service/load") !== -1) {
        return url.indexOf("?reference_number=") !== -1;
      }
      return this.href === url || this.href === path;
    });
    element.parentsUntil(".sidebar-nav").each(function (index) {
      if ($(this).is("li") && $(this).children("a").length !== 0) {
        $(this).children("a").addClass("active");
        if ($(this).parent("ul#sidebarnav").length === 0) {
          $(this).addClass("active");
        } else {
          self.setState({ selected: $(this).attr("data-selected") });
        }
      } else if (!$(this).is("ul") && $(this).children("a").length === 0) {
        if ($(this).attr("data-selected")) {
          self.setState({ selected: $(this).attr("data-selected") });
        }
      } else if ($(this).is("ul")) {
        $(this).addClass("in");
      }
    });
    element.addClass("active");
  }

  componentWillReceiveProps(nextProps) {
    //#region carrier
    if (
      nextProps.UnAssignedrequests &&
      nextProps.UnAssignedrequests.unAssignedShipment.shipment &&
      nextProps.UnAssignedrequests.unAssignedShipment.shipment.length > 0
    ) {
      let requestedLoads =
        nextProps.UnAssignedrequests.unAssignedShipment.shipment.filter(
          function (d) {
            return d.MCNumber === getStorage("carrier_MCNumber");
          }
        );
      setStorage("requestedLoads", requestedLoads.length);
      this.setState({
        NoOfrequestedLoads: requestedLoads.length,
      });
    }
    if (nextProps.changeNav)
      this.setState({ currentUrl: nextProps.changeNav.commonUrl });
    //#endregion
  }

  logout = () => {
    $(".sidebartoggler").click();
    setTimeout(() => {
       this.props.commonActions.logoutUser();
      // $("#main-wrapper").addClass("hide-sidebar");
    }, 1000);
  };

  navigateToCreateOrder() {
    browserHistory.push("/create-order");
  }
  //#endregion

  //#region carrier
  addDriver() {
    this.setState({
      addDriverModal: true,
    });
  }

  addDriverELD() {
    browserHistory.push("/add-driver-eld");
  }

  close() {
    this.setState({
      addDriverModal: false,
    });
  }

  displayConfirm() {
    this.setState({
      addDriverModal: false,
      confirmDriverModal: true,
    });
  }

  filterDriver = (status) => {
    this.setState({ defaultDriver: status });
    this.props.commonActions.filterUsers(status);
  };

  closeConfirm() {
    this.setState({
      confirmDriverModal: false,
    });
  }

  checkUserPermisison = (permission) => {
    let allow = false;
    const { user } = this.state;
    if (user) {
      if (user.role === "carrier") {
        allow = true;
      } else if (user.permissions) {
        permission.map((x) => {
          if (user.permissions.indexOf(x) > -1) {
            return (allow = true);
          }
        });
      }
      return allow;
    }
  };

  getThemeSettings = () => {
    let carrierId = getCarrierId();
    getMainTheme({carrierId:carrierId})
    .then((res) => {
      if(res){
        setStorage("themeSetting", JSON.stringify(res));
        this.setState({
          themeSetting: res
        })
        res.themeName && changeTheme(themesOptions.find(theme=>theme.name===res.themeName));
      }
    })
    .catch((err) =>{
      // console.log(err)
    })
  }
  render() {
    const { ismenuhoveredcheck } = this.state;

    const { reports } =
      this.state.user && this.state.user.reports ? this.state.user : [];
    let hideTracking = false;
    if (this.state.user) {
      if (["fleetcustomer", "customer"].indexOf(this.state.user.role) > -1) {
        hideTracking = true;
      }
      if (
        this.state.user.role === "fleetmanager" &&
        this.state.user.fleetManager.isCustomer
      ) {
        hideTracking = true;
      }
    }

    //  let isNotConsignee=true;
    //   if(this.state.customerType.length===1 && this.state.customerType.includes('consignee')){
    //     isNotConsignee=false
    //   }
    const carrierDetail = JSON.parse(getStorage('carrierDetail'));
    let loggedInUser = JSON.parse(getStorage('loggedInUser'));
    let carrierId = null;
    if (loggedInUser && loggedInUser.role === 'fleetmanager') {
      carrierId = loggedInUser.fleetManager.carrier;
    }else if(loggedInUser && loggedInUser.role === 'carrier') {
      carrierId = loggedInUser._id;
    }
    return (
      <aside
        className={`left-sidebar ${
          this.state.isMenuHovered ? "ishovered shadow-5" : ""
        }`}
        ismenuhoveredcheck={ismenuhoveredcheck.toString()}
        onMouseEnter={this.handleMenuEnter}
        onMouseLeave={this.handleMenuLeave}
      >
        {/* Sidebar scroll*/}

        <div className="border-radius-default" component="div">
          {/* Sidebar navigation*/}
          <nav className="sidebar-nav">
            <div className="d-flex align-items-center justify-content-between">
              <Link className="navbar-brand" to="/track1">
                {/* Logo Expand */}
                {
                  this.state.themeSetting && (this.state.themeSetting.companyLogoUrl && this.state.themeSetting.companyLogoUrl!=='NOURL') ?
                  <img className="navbar-brand__logo-big" src={`${this.state.themeSetting.companyLogoUrl}`}
                  onError={({ currentTarget }) => {
                    currentTarget.src=noImage
                  }} />
                  :
                  <LogoPortPro className="navbar-brand__logo-big" />
                }
                {/* Logo Small */}
                {
                  this.state.themeSetting && (this.state.themeSetting.logoUrlMini && this.state.themeSetting.logoUrlMini!=='NOURL') ?
                  <img className="navbar-brand__logo-small" src={`${this.state.themeSetting.logoUrlMini}`} 
                  onError={({ currentTarget }) => {
                    currentTarget.src=noImage
                  }} />

                  :
                  <LogoPortProSmall className="navbar-brand__logo-small" />
                }                
              </Link>
            </div>

            <div id="sidebarnav" className="sidebar-content">

              {/* unrestricted routes */}
              {
                //#region dispatcher
                carrierDetail?.isShiposCarrier && this.checkUserPermisison(["dispatcher"]) && (
                  <div
                    className={`sidebar-item ${
                      this.state.selected == 111 ? "selected" : ""
                    }`}
                    data-selected="111"
                  >
                    <Link
                      className="sidebar-link"
                      to="/tms/Dispatcher"
                      onClick={() => {
                        this.setState({
                          currentUrl: "/tms/Dispatcher",
                          selected: 111,
                        });
                      }}
                      activeclassname={"active"}
                    >
                      <i className="uil uil-monitor"></i>
                      <span className="hide-menu">Dispatcher</span>
                    </Link>
                  </div>
                )
                //#endregion
              }
              {
                //#region online tendered loads
                carrierDetail?.isShiposCarrier && this.checkUserPermisison(["customer_service_online_tendered_loads"]) && (
                  <div
                    className={`sidebar-item ${
                      this.state.selected == 222 ? "selected" : ""
                    }`}
                    data-selected="222"
                  >
                    <Link
                      className="sidebar-link"
                      to="/new-tendered"
                      onClick={() => {
                        this.setState({
                          selected: 222,
                          currentUrl: "/new-tendered",
                        });
                      }}
                      activeClassName={"active"}
                    >
                      <IconUserAlt />
                      <span className="hide-menu">Online Tendered Loads V2</span>
                    </Link>
                  </div>
                )
                //#endregion
              }
              {
              //#region general info setting
                carrierDetail?.isShiposCarrier && this.checkUserPermisison(["settings_general_info"]) && (
                  <div
                    className={`sidebar-item ${
                      this.state.selected == 333 ? "selected" : ""
                    }`}
                    data-selected="333"
                  >
                    <Link
                      className="sidebar-link"
                      to="/settings/general-info"
                      onClick={() =>
                        this.setState({
                          selected: 333,
                          currentUrl: "/settings/general-info",
                        })
                      }
                      activeclassname={"active"}
                    >
                      
                    <IconSettings />
                    <span className="hide-menu">General Info</span>
                    </Link>
                  </div>
                )
                //#endregion
              }
              {
                carrierDetail?.isShiposCarrier && <div
                  className={`sidebar-item ${
                    this.state.selected === "driver" ? "active" : ""
                  } ${
                    this.state.isMenuClicked === "driver" ? "isclicked" : ""
                  }`}
                  onClick={() => this.handleMenuClick("driver")}
                >
                  <div className="sidebar-link has-arrow">
                    <IconSteering />
                    <span className="hide-menu">Drivers</span>
                  </div>
                  <div aria-expanded="false" className="collapse first-level">
                    {this.checkUserPermisison(["other_profile_driver"]) && (
                      <Link
                        className="first-level__link"
                        to="/tms/Driver"
                        onClick={() =>
                          this.setState({
                            selected: "driver",
                            currentUrl: "/tms/Driver",
                          })
                        }
                        activeclassname={"active"}
                      >
                        Driver Profiles
                      </Link>
                    )}
                    {this.checkUserPermisison(["other_assign_truck"]) && 
                      <Link
                        className="first-level__link"
                        to="/tms/AssignTruck"
                        onClick={() =>
                          this.setState({
                            selected: "driver",
                            currentUrl: "/tms/AssignTruck",
                          })
                        }
                        activeclassname={"active"}
                      >
                        Truck Assignments
                      </Link>
                    }
                    {this.checkUserPermisison(["safety_truck_owner"]) && 
                      <Link
                        className="first-level__link"
                        to="/tms/fleetTruck"
                        onClick={() =>
                          this.setState({
                            selected: "driver",
                            currentUrl: "/tms/fleetTruck",
                          })
                        }
                        activeclassname={"active"}
                      >
                        Truck Owners
                      </Link>
                    }
                    {JSON.parse(getStorage("carrierDetail"))?.newDriverPay ? 
                    this.checkUserPermisison(["other_driver_pay_rate"]) && 
                      <Link
                        className="first-level__link"
                        to="/tms/driver-pay-rates"
                        onClick={() =>
                          this.setState({
                            selected: "driver",
                            currentUrl: "/tms/driver-pay-rates",
                          })
                        }
                        activeClassName={"active"}
                      >
                        Driver Pay Rates
                      </Link>
                    :
                    this.checkUserPermisison(["other_driver_pay_rate"]) && 
                      <Link
                        className="first-level__link"
                        to="/tms/payment-setting"
                        onClick={() =>
                          this.setState({
                            selected: "driver",
                            currentUrl: "/tms/payment-setting",
                          })
                        }
                        activeclassname={"active"}
                      >
                        Driver Pay Rates
                      </Link>
                    }
                    {this.checkUserPermisison(["billing_settlement_setting"]) && 
                      <Link
                        className="first-level__link"
                        to="/tms/billing/settings"
                        onClick={() =>
                          this.setState({
                            selected: "driver",
                            currentUrl: "/tms/billing/settings",
                          })
                        }
                        activeclassname={"active"}
                      >
                        Driver Deduction Rates
                      </Link>
                    }
                    {this.checkUserPermisison(["other_dynamic_driver_pay"]) && 
                      <Link
                        className="first-level__link"
                        to="/dynamic-driverPay"
                        onClick={() =>
                          this.setState({
                            selected: "driver",
                            currentUrl: "/dynamic-driverPay",
                          })
                        }
                        activeclassname={"active"}
                      >
                        Dynamic Driver Pay
                      </Link>
                    }
                  </div>
                </div>
              }
              {
                //#region Customers
                carrierDetail?.isShiposCarrier && this.checkUserPermisison([
                  "other_profile_customer",
                  "other_customer_rate",
                  "other_dynamic_pricing",
                  "other_customer_discount",
                  "other_group_customer"
                ]) && (
                  <div
                    className={`sidebar-item ${
                      this.state.selected === "customer" ? "active" : ""
                    } ${
                      this.state.isMenuClicked === "customer" ? "isclicked" : ""
                    }`}
                    onClick={() => this.handleMenuClick("customer")}
                  >
                    <div className="sidebar-link has-arrow">
                      <IconUserBox />
                      <span className="hide-menu">Customers</span>
                    </div>
                    <div aria-expanded="false" className="collapse first-level">
                      {this.checkUserPermisison(["other_profile_customer"]) && (
                        <Link
                          className="first-level__link"
                          to="/tms/customer"
                          onClick={() =>
                            this.setState({
                              selected: "customer",
                              currentUrl: "/tms/customer",
                            })
                          }
                          activeclassname={"active"}
                        >
                          Customer Profile
                        </Link>
                      )}
                      {this.checkUserPermisison([
                        "other_customer_rate",
                        "other_dynamic_pricing",
                        "other_customer_discount"
                      ]) && (
                        <Link
                          className="first-level__link"
                          to="/tms/load-price-settings"
                          onClick={() =>
                            this.setState({
                              selected: "customer",
                              currentUrl: "/tms/load-price-settings",
                            })
                          }
                          activeclassname={"active"}
                        >
                          Customer Rates
                        </Link>

                      )}
                      {this.checkUserPermisison(["other_group_customer"]) && (
                        <Link
                          className="first-level__link"
                          to="/tms/FleetCustomer"
                          onClick={() =>
                            this.setState({
                              selected: "customer",
                              currentUrl: "/tms/FleetCustomer",
                            })
                          }
                          activeclassname={"active"}
                        >
                          Group Customer
                        </Link>
                      )}
                    </div>
                  </div>
                )
                //#endregion Customer
              }

              {
                carrierDetail?.isShiposCarrier && <div
                    className={`sidebar-item ${
                      this.state.selected === "billing-top" ? "active" : ""
                    } ${
                      this.state.isMenuClicked === "billing-top" ? "isclicked" : ""
                    }`}
                    onClick={() => this.handleMenuClick("billing-top")}
                  >
                    <div className="sidebar-link has-arrow">
                      <IconBilling />
                      <span className="hide-menu">Accounts Receivable</span>
                    </div>
                    <div aria-expanded="false" className="collapse first-level">
                      {this.checkUserPermisison([
                        "billing_account_receivable",
                      ]) && (
                        <Link
                          className="first-level__link"
                          to={"/tms/billing/account-receivable"}
                          onClick={() =>
                            this.setState({
                              selected: "billing-top",
                              currentUrl: "/tms/billing/account-receivable",
                            })
                          }
                          activeclassname={"active"}
                        >
                          Dashboard
                        </Link>
                      )}
                    </div>
                  </div>
              }


              {carrierDetail?.isShiposCarrier && 
                <div className="sidebar-link px-3 d-flex justify-content-center my-4">
                  <div className="hide-menu" id="sidebar-separator"><span className="bg-white px-2">{this.state.isMenuHovered && "Pro Features"}</span></div>
              </div>}
              {/* restricted routes */}

              {!hideTracking &&
                this.state.user &&
                (["carrier"].includes(this.state.user.role) ||
                  (["fleetmanager"].includes(this.state.user.role) &&
                    this.checkUserPermisison(["tracking"]) &&
                    this.state.user.fleetManager &&
                    !this.state.user.fleetManager.isCustomer)) && (
                  <div  className={`sidebar-item ${
                    this.state.selected == 1 ? "selected" : ""
                  }`}
                  data-selected="1">
                    <Link
                      className="sidebar-link"
                      to="/track1"
                      onClick={() => {
                        this.setState({
                          currentUrl: "/customer-shipments",
                          selected: 1,
                        });
                      }}
                      activeclassname={"active"}
                    >
                      <i className="uil uil-map"></i>
                      <span className="hide-menu">Tracking</span>
                    </Link>
                  </div>
                )}
              {this.state.acl &&
                this.state.user &&
                (this.state.acl.includes("customer") ||
                  this.state.user.role === "fleetcustomer" ||
                  (this.state.user.role === "fleetmanager" &&
                    this.state.user.fleetManager.isCustomer &&
                    this.checkUserPermisison(["customer_shipments"]))) && (
                      <div className={`sidebar-item ${
                        this.state.selected === 1 ? "active" : ""
                      }`}
                      data-selected="1">
                    <Link
                      className="sidebar-link"
                      to="/customer-shipments"
                      onClick={() => {
                        this.setState({ currentUrl: "/customer-shipments", selected: 1 });
                      }}
                      activeclassname={"active"}
                    >
                      <i className="uil uil-location-point"></i>
                      <span className="hide-menu">Tracking</span>
                    </Link>
                  </div>
                )}
              {this.state.acl &&
                this.state.user &&
                (this.state.acl.includes("customer") ||
                  this.state.user.role === "fleetcustomer" ||
                  (this.state.user.role === "fleetmanager" &&
                    this.state.user.fleetManager.isCustomer &&
                    this.checkUserPermisison(["customer_employee_load"]))) && (
                      <div className={`sidebar-item ${this.state.selected === 'loads' ? "active" : ""}`} data-selected = 'loads'>
                    <Link
                      className="sidebar-link"
                      to="/loads"
                      onClick={() => {
                        this.setState({ currentUrl: "/loads", selected : 'loads' });
                      }}
                      activeclassname={"active"}
                    >
                      <i className="uil uil-truck-loading"></i>
                      <span className="hide-menu">Loads</span>
                    </Link>
                  </div>
                )}

              {this.state.acl &&
                this.state.user &&
                (this.state.acl.includes("customer") ||
                  this.state.user.role === "fleetcustomer" ||
                  (this.state.user.role === "fleetmanager" &&
                    this.state.user.fleetManager.isCustomer &&
                    this.checkUserPermisison(["dropped_containers"]))) && (
                  <React.Fragment>
                    <div
                      className={
                        this.state.currentUrl ==
                        "/tms/at-yard-container-loads"
                          ? "sidebar-item active"
                          : "sidebar-item"
                      }
                    >
                      <Link
                        className="sidebar-link"
                        to="/tms/at-yard-container-loads"
                        onClick={() =>
                          this.setState({
                            selected: "dropped",
                            currentUrl:
                              "/tms/at-yard-container-loads",
                          })
                        }
                        activeclassname={"active"}
                      >
                        <i className="uil uil-airplay mr-1" />
                        <span className="hide-menu"> Dropped Containers </span>
                      </Link>
                    </div>
                  </React.Fragment>
                )}

              {this.state.acl &&
                this.state.user &&
                (this.state.acl.includes("customer") ||
                  this.state.user.role === "fleetcustomer" ||
                  (this.state.user.role === "fleetmanager" &&
                    this.state.user.fleetManager.isCustomer &&
                    this.checkUserPermisison(["account_payable"]))) && (
                  // && (isNotConsignee)

                  <div className= {`sidebar-item ${this.state.selected === 'accPayable' ? "active" : ""} `} data-selected='accPayable'>
                    <Link
                      className="sidebar-link"
                      to="/tms/account-receivable"
                      onClick={() => {
                        this.setState({ currentUrl: "/tms/account-receivable", selected : 'accPayable' });
                      }}
                      activeclassname={"active"}
                    >
                      <IconPayment />
                      <span className="hide-menu">Accounts Payable</span>
                    </Link>
                  </div>
                )}

              {
                //#region dispatcher
                !carrierDetail?.isShiposCarrier && this.checkUserPermisison(["dispatcher"]) && (
                  <div
                    className={`sidebar-item ${
                      this.state.selected == 2 ? "selected" : ""
                    }`}
                    data-selected="2"
                  >
                    <Link
                      className="sidebar-link"
                      to="/tms/Dispatcher"
                      onClick={() => {
                        this.setState({
                          currentUrl: "/tms/Dispatcher",
                          selected: 2,
                        });
                      }}
                      activeclassname={"active"}
                    >
                      <i className="uil uil-monitor"></i>
                      <span className="hide-menu">Dispatcher</span>
                    </Link>
                  </div>
                )
                //#endregion
              }
               {
                //#region employees
                this.state.acl &&
                this.state.user &&
                (this.state.acl.includes("customer") ||
                  this.state.user.role === "fleetcustomer" ||
                  (this.state.user.role === "fleetmanager" &&
                    this.state.user.fleetManager.isCustomer )) && (
                  <div
                    className={`sidebar-item ${
                      this.state.selected === 3 ? "selected" : ""
                    }`}
                    data-selected="3"
                  >
                    <Link
                      className="sidebar-link"
                      to="/tms/fleetmanagers"
                      onClick={() => {
                        this.setState({
                          currentUrl: "/tms/fleetmanagers",
                          selected: 3,
                        });
                      }}
                      activeclassname={"active"}
                    >
                      <IconUsersGroup/>
                      <span className="hide-menu">Employees</span>
                    </Link>
                  </div>
                )
                //#endregion
              }
              {
                //#region employees
                this.state.acl &&
                this.state.user &&
                (this.state.acl.includes("customer") ||
                  this.state.user.role === "fleetcustomer" ||
                  (this.state.user.role === "fleetmanager" &&
                    this.state.user.fleetManager.isCustomer )) && (
                  <div
                    className={`sidebar-item ${
                      this.state.selected === 4 ? "selected" : ""
                    }`}
                    data-selected="4"
                  >
                    <Link
                      className="sidebar-link"
                      to="/tms/customer"
                      onClick={() => {
                        this.setState({
                          currentUrl: "/tms/customer",
                          selected: 4,
                        });
                      }}
                      activeclassname={"active"}
                    >
                      <i className="uil uil-users-alt"></i>
                      <span className="hide-menu">Profiles</span>
                    </Link>
                  </div>
                )
                //#endregion
              }
              {
                //#region customer_service
                this.checkUserPermisison([
                  "customer_service_dashboard",
                  "customer_service_load_info",
                  "customer_service_quotes",
                  "customer_service_dropped_container",
                  "customer_service_tendered_loads",
                  "customer_service_load_calendar",
                  "customer_service_bulk_upload",
                  "customer_service_customer_messaging",
                  "customer_service_drive_messaging",
                  "customer_service_group_messaging",
                  "customer_service_employee_messaging",
                  "customer_service_deleted_load",
                  "customer_service_online_tendered_loads",

                ]) && (
                  <div
                    className={`sidebar-item ${
                      this.state.selected === "customer-service" ? "active" : ""
                    } ${
                      this.state.isMenuClicked === "customer-service"
                        ? "isclicked"
                        : ""
                    }`}
                    onClick={() => this.handleMenuClick("customer-service")}
                  >
                    <div
                      className="sidebar-link has-arrow"
                      href="javascript:void(0)"
                      aria-expanded="false"
                      activeclassname={"active"}
                    >
                      <IconUserAlt />
                      <span className="hide-menu">Customer Service</span>
                    </div>
                    <div aria-expanded="false" className="collapse first-level">
                      {this.checkUserPermisison([
                        "customer_service_dashboard",
                      ]) && (
                        <Link
                          className="first-level__link"
                          activeclassname="active"
                          to="/tms/customer-dashboard"
                          onClick={() => {
                            this.setState({
                              selected: "customer-service",
                              currentUrl: "/tms/customer-dashboard",
                            });
                          }}
                        >
                          Customer Dashboard
                        </Link>
                      )}
                      {!isNewModal() && this.checkUserPermisison(["customer_service_load_info"]) && (
                        <Link
                          className="first-level__link"
                          to="/tms/customer-service/load"
                          onClick={() =>
                            this.setState({
                              selected: "customer-service",
                              currentUrl: "/tms/customer-service/load",
                            })
                          }
                          activeclassname="active"
                        >
                          Loads
                        </Link>
                      )}
                      {this.checkUserPermisison(["customer_service_quotes"]) && (
                        <Link
                          className="first-level__link"
                          to="/tms/load-quote-settings"
                          onClick={() =>
                            this.setState({
                              selected: "customer-service",
                              currentUrl: "/tms/load-quote-settings",
                            })
                          }
                          activeclassname="active"
                        >
                          Quotes
                        </Link>
                      )}

                      {this.checkUserPermisison([
                        "customer_service_dropped_container",
                      ]) && (
                        <Link
                          className="first-level__link"
                          to="/tms/customer-service/at-yard-container-loads"
                          onClick={() =>
                            this.setState({
                              selected: "customer-service",
                              currentUrl:
                                "/tms/customer-service/at-yard-container-loads",
                            })
                          }
                          activeclassname={"active"}
                        >
                          Yard Check
                        </Link>
                      )}
                      {getStorage("currentUserRole") !== "customer" &&
                        getStorage("currentUserRole") !== "fleetcustomer" &&
                        // getStorage("currentUserRole") !== "fleetmanager" && 
                        this.checkUserPermisison(["customer_service_tendered_loads"]) &&
                        (
                          
                            <Link
                              className="first-level__link"
                              to="/tendered"
                              onClick={() => {
                                this.setState({
                                  selected: 'customer-service',
                                  currentUrl: "tendered",
                                });
                              }}
                              activeclassname={"active"}
                            >
                              Tendered Loads
                            </Link>
                      
                        )}

                        {getStorage("currentUserRole") !== "customer" &&
                        getStorage("currentUserRole") !== "fleetcustomer" &&
                        // getStorage("currentUserRole") !== "fleetmanager" && 
                        this.checkUserPermisison(["customer_service_tendered_loads"]) &&
                        (
                          
                            <Link
                              className="first-level__link"
                              to="/new-tendered"
                              onClick={() => {
                                this.setState({
                                  selected: 'customer-service',
                                  currentUrl: "tendered",
                                });
                              }}
                              activeclassname={"active"}
                            >
                             New Tendered Loads
                            </Link>
                      
                        )}

                        
                      {this.checkUserPermisison([
                        "customer_service_load_calendar",
                      ]) && (
                        <Link
                          className="first-level__link"
                          to="/tms/customer-service/calendar"
                          onClick={() =>
                            this.setState({
                              selected: "customer-service",
                              currentUrl: "/tms/customer-service/calendar",
                            })
                          }
                          activeclassname={"active"}
                        >
                          Load Calendar
                        </Link>
                      )}
                      {this.checkUserPermisison([
                        "customer_service_bulk_upload",
                      ]) && (
                        <Link
                          className="first-level__link"
                          to="/tms/customer-service/bulk-upload1"
                          onClick={() =>
                            this.setState({
                              selected: "customer-service",
                              currentUrl: "/tms/customer-service/bulk-upload1",
                            })
                          }
                          activeclassname={"active"}
                        >
                          Bulk Uploads
                        </Link>
                      )}
                      {this.checkUserPermisison([
                        "customer_service_employee_messaging",
                        "customer_service_drive_messaging",
                        "customer_service_group_messaging",
                        "customer_service_customer_messaging"
                      ]) && (
                      <Link
                        className="first-level__link"
                        to="/driver-messaging"
                        onClick={() =>
                          this.setState({
                            selected: "customer-service",
                            currentUrl: "/driver-messaging",
                          })
                        }
                        activeclassname={"active"}
                      >
                        Messaging
                      </Link>
                      )}
                      {this.checkUserPermisison([
                        "customer_service_deleted_load",
                      ]) && (
                        <Link
                          className="first-level__link"
                          to="/tms/deleted-loads"
                          onClick={() =>
                            this.setState({
                              selected: "customer-service",
                              currentUrl: "/tms/deleted-loads",
                            })
                          }
                          activeclassname={"active"}
                        >
                          Deleted Loads
                        </Link>
                      )}
                      { getStorage("currentUserRole") !== "customer" &&
                        getStorage("currentUserRole") !== "fleetcustomer" &&
                        // getStorage("currentUserRole") !== "fleetmanager" && 
                        this.checkUserPermisison(["customer_service_online_tendered_loads"]) &&
                        (
                          
                            <Link
                              className="first-level__link"
                              to="/tendered-online"
                              onClick={() => {
                                this.setState({
                                  selected: 'customer-service',
                                  currentUrl: "/tendered-online",
                                });
                              }}
                              activeClassName={"active"}
                            >
                              Online Tendered Loads
                            </Link>
                      
                        )}
                          {getStorage("currentUserRole") !== "customer" &&
                        getStorage("currentUserRole") !== "fleetcustomer" &&
                        // getStorage("currentUserRole") !== "fleetmanager" && 
                        this.checkUserPermisison(["customer_service_online_tendered_loads"]) &&
                        (
                          
                            <Link
                              className="first-level__link"
                              to="/new-tendered"
                              onClick={() => {
                                this.setState({
                                  selected: 'customer-service',
                                  currentUrl: "/new-tendered",
                                });
                              }}
                              activeClassName={"active"}
                            >
                              Online Tendered Loads V2
                            </Link>
                      
                        )}
                    </div>
                  </div>
                )
                //#endregion
              }

              {
                //#region BILLING
                this.checkUserPermisison([
                  "billing_account_receivable",
                  "billing_batch_apply_payment",
                  "billing_subaccount_receivable",
                  "reports_aging",
                  "billing_chassis_validation",
                  "billing_problem_invoices",
                ]) && (
                  <div
                    className={`sidebar-item ${
                      this.state.selected === "billing" ? "active" : ""
                    } ${
                      this.state.isMenuClicked === "billing" ? "isclicked" : ""
                    }`}
                    onClick={() => this.handleMenuClick("billing")}
                  >
                    <div className="sidebar-link has-arrow">
                      <IconBilling />
                      <span className="hide-menu">Accounts Receivable</span>
                    </div>
                    <div aria-expanded="false" className="collapse first-level">
                      {!carrierDetail?.isShiposCarrier && this.checkUserPermisison([
                        "billing_account_receivable",
                      ]) && (
                        <Link
                          className="first-level__link"
                          to="/tms/billing/account-receivable"
                          onClick={() =>
                            this.setState({
                              selected: "billing",
                              currentUrl: "/tms/billing/account-receivable",
                            })
                          }
                          activeclassname={"active"}
                        >
                          Dashboard
                        </Link>
                      )}
                      {this.checkUserPermisison([
                        "billing_batch_apply_payment",
                      ]) && (
                        <Link
                          className="first-level__link"
                          to="/tms/billing/payment"
                          onClick={() =>
                            this.setState({
                              selected: "billing",
                              currentUrl: "/tms/billing/payment",
                            })
                          }
                          activeclassname={"active"}
                        >
                          Apply Payments
                        </Link>
                      )}
                      {this.checkUserPermisison([
                        "billing_subaccount_receivable",
                      ]) && (
                        <Link
                          className="first-level__link"
                          to="/tms/billing/sub-customer-account-receivable"
                          onClick={() =>
                            this.setState({
                              selected: "billing",
                              currentUrl: "/tms/billing/account-receivable",
                            })
                          }
                          activeclassname={"active"}
                        >
                          Sub Accounts Receivable
                        </Link>
                      )}
                      {(this.checkUserPermisison(["reports_aging"]) ||
                        (this.state.acl &&
                          this.state.acl.includes("customer")) ||
                        (this.state.user &&
                          this.state.user.role === "fleetcustomer")) && (
                          <Link
                            className="first-level__link"
                            to="/tms/billing/aging1"
                            onClick={() =>
                              this.setState({
                                selected: "billing",
                                currentUrl: "/tms/billing/aging1",
                              })
                            }
                            activeclassname={"active"}
                          >
                            Aging
                          </Link>
                       )}
                      {/* // Customer Service */}
                      {this.checkUserPermisison(["billing_chassis_validation"]) &&
                        <Link
                          className="first-level__link"
                          to="/tms/customer-service/chassis-validation"
                          onClick={() =>
                            this.setState({
                              selected: "billing",
                              currentUrl:
                                "/tms/customer-service/chassis-validation",
                            })
                          }
                          activeclassname={"active"}
                        >
                          Chassis Audit
                        </Link>
                      }
                      {this.checkUserPermisison(["billing_problem_invoices"]) && ((this.state.user &&this.state.user.qbAccount !== undefined)||(this.state.carrier && this.state.carrier.qbAccount !== undefined)) &&
                        <Link
                          className="first-level__link"
                          to="/tms/desyncedQBLoads"
                          onClick={() =>
                            this.setState({
                              selected: "billing",
                              currentUrl: "/tms/desyncedQBLoads",
                            })
                          }
                          activeclassname={"active"}
                        >
                          Problem Invoices
                        </Link>
                      }
                    </div>
                  </div>
                )
                //#endregion
              }

              {
                //#region BILLING
                this.checkUserPermisison([
                  "billing_driver_pay",
                  "billing_driver_settlement",
                  "dynamic_dynamic_expense",
                ]) && (
                  <div
                    className={`sidebar-item ${
                      this.state.selected === "payable" ? "active" : ""
                    } ${
                      this.state.isMenuClicked === "payable" ? "isclicked" : ""
                    }`}
                    onClick={() => this.handleMenuClick("payable")}
                  >
                    <div className="sidebar-link has-arrow">
                      <IconPayment />
                      <span className="hide-menu">Accounts Payable</span>
                    </div>
                    <div aria-expanded="false" className="collapse first-level">
                      {this.checkUserPermisison(["billing_driver_pay"]) && (
                        <Link
                          className="first-level__link"
                          to="/tms/billing/driver-pay"
                          onClick={() => {
                            this.setState({
                              selected: "payable",
                              currentUrl: "/tms/billing/driver-pay",
                            });
                          }}
                          activeclassname={"active"}
                        >
                          Driver Pay
                        </Link>
                      )}
                      {this.checkUserPermisison([
                        "billing_driver_settlement",
                      ]) && (
                        <Link
                          className="first-level__link"
                          to="/tms/billing/settlements"
                          onClick={() =>
                            this.setState({
                              selected: "payable",
                              currentUrl: "/tms/billing/settlements",
                            })
                          }
                          activeclassname={"active"}
                        >
                          Driver Settlements
                        </Link>
                      )}
                    

                      {/* Dynamic Expenses */}
                      {this.checkUserPermisison([
                        "dynamic_dynamic_expense",
                      ]) &&
                         <Link
                          className="first-level__link"
                          to="/tms/dynamic-expense"
                          onClick={() =>
                            this.setState({
                              selected: "payable",
                              currentUrl: "/tms/dynamic-expense",
                            })
                          }
                          activeclassname={"active"}
                        >
                          Dynamic Expense
                        </Link>
                      }
                    </div>
                  </div>
                )
                //#endregion
              }

              {
                //#region SAFETY
                !carrierDetail?.isShiposCarrier && this.checkUserPermisison([
                  "other_profile_driver",
                  "other_assign_truck",
                  "safety_truck_owner",
                  "other_driver_pay_rate",
                  "billing_settlement_setting",
                  "other_dynamic_driver_pay"
                ]) && (
                  <div
                    className={`sidebar-item ${
                      this.state.selected === "driver" ? "active" : ""
                    } ${
                      this.state.isMenuClicked === "driver" ? "isclicked" : ""
                    }`}
                    onClick={() => this.handleMenuClick("driver")}
                  >
                    <div className="sidebar-link has-arrow">
                      <IconSteering />
                      <span className="hide-menu">Drivers</span>
                    </div>
                    <div aria-expanded="false" className="collapse first-level">
                      {this.checkUserPermisison(["other_profile_driver"]) && (
                        <Link
                          className="first-level__link"
                          to="/tms/Driver"
                          onClick={() =>
                            this.setState({
                              selected: "driver",
                              currentUrl: "/tms/Driver",
                            })
                          }
                          activeclassname={"active"}
                        >
                          Driver Profiles
                        </Link>
                      )}
                      {this.checkUserPermisison(["other_assign_truck"]) && 
                        <Link
                          className="first-level__link"
                          to="/tms/AssignTruck"
                          onClick={() =>
                            this.setState({
                              selected: "driver",
                              currentUrl: "/tms/AssignTruck",
                            })
                          }
                          activeclassname={"active"}
                        >
                          Truck Assignments
                        </Link>
                      }
                      {this.checkUserPermisison(["safety_truck_owner"]) && 
                        <Link
                          className="first-level__link"
                          to="/tms/fleetTruck"
                          onClick={() =>
                            this.setState({
                              selected: "driver",
                              currentUrl: "/tms/fleetTruck",
                            })
                          }
                          activeclassname={"active"}
                        >
                          Truck Owners
                        </Link>
                      }
                      {JSON.parse(getStorage("carrierDetail"))?.newDriverPay ? 
                      this.checkUserPermisison(["other_driver_pay_rate"]) && 
                        <Link
                          className="first-level__link"
                          to="/tms/driver-pay-rates"
                          onClick={() =>
                            this.setState({
                              selected: "driver",
                              currentUrl: "/tms/driver-pay-rates",
                            })
                          }
                          activeClassName={"active"}
                        >
                          Driver Pay Rates
                        </Link>
                      :
                      this.checkUserPermisison(["other_driver_pay_rate"]) && 
                        <Link
                          className="first-level__link"
                          to="/tms/payment-setting"
                          onClick={() =>
                            this.setState({
                              selected: "driver",
                              currentUrl: "/tms/payment-setting",
                            })
                          }
                          activeclassname={"active"}
                        >
                          Driver Pay Rates
                        </Link>
                      }
                      {this.checkUserPermisison(["billing_settlement_setting"]) && 
                        <Link
                          className="first-level__link"
                          to="/tms/billing/settings"
                          onClick={() =>
                            this.setState({
                              selected: "driver",
                              currentUrl: "/tms/billing/settings",
                            })
                          }
                          activeclassname={"active"}
                        >
                          Driver Deduction Rates
                        </Link>
                      }
                      {this.checkUserPermisison(["other_dynamic_driver_pay"]) && 
                        <Link
                          className="first-level__link"
                          to="/dynamic-driverPay"
                          onClick={() =>
                            this.setState({
                              selected: "driver",
                              currentUrl: "/dynamic-driverPay",
                            })
                          }
                          activeclassname={"active"}
                        >
                          Dynamic Driver Pay
                        </Link>
                      }
                    </div>
                  </div>
                )
                //#endregion of Drivers
              }
              {
                //#region Equipments
                this.checkUserPermisison([
                  "other_profile_truck",
                  "other_profile_chassis",
                  "other_profile_trailer"
                ]) && (
                  <div
                    className={`sidebar-item ${
                      this.state.selected === "equipment" ? "active" : ""
                    } ${
                      this.state.isMenuClicked === "equipment"
                        ? "isclicked"
                        : ""
                    }`}
                    onClick={() => this.handleMenuClick("equipment")}
                  >
                    <div className="sidebar-link has-arrow">
                      <IconTruckFront />

                      <span className="hide-menu">Equipment</span>
                    </div>
                    <div aria-expanded="false" className="collapse first-level">
                      {this.checkUserPermisison(["other_profile_truck"]) && (
                        <Link
                          className="first-level__link"
                          to="/tms/Truck"
                          onClick={() =>
                            this.setState({
                              selected: "equipment",
                              currentUrl: "/tms/Truck",
                            })
                          }
                          activeclassname={"active"}
                        >
                          Truck Profiles
                        </Link>
                      )}
                      {this.checkUserPermisison(["other_profile_chassis"]) && (
                        <Link
                          className="first-level__link"
                          to="/tms/AddChassis"
                          onClick={() =>
                            this.setState({
                              selected: "equipment",
                              currentUrl: "/tms/AddChassis",
                            })
                          }
                          activeclassname={"active"}
                        >
                          Chassis Profiles
                        </Link>
                      )}

                      {this.checkUserPermisison(["other_profile_trailer"]) && (
                        <Link
                          className="first-level__link"
                          to="/tms/Trailer"
                          onClick={() =>
                            this.setState({
                              selected: "equipment",
                              currentUrl: "/tms/Trailer",
                            })
                          }
                          activeclassname={"active"}
                        >
                          Trailer Profiles
                        </Link>
                      )}
                    </div>
                  </div>
                )
                //#endregion Equipments
              }
              {
                //#region Customers
                !carrierDetail?.isShiposCarrier && this.checkUserPermisison([
                  "other_profile_customer",
                  "other_customer_rate",
                  "other_dynamic_pricing",
                  "other_customer_discount",
                  "other_group_customer"
                ]) && (
                  <div
                    className={`sidebar-item ${
                      this.state.selected === "customer" ? "active" : ""
                    } ${
                      this.state.isMenuClicked === "customer" ? "isclicked" : ""
                    }`}
                    onClick={() => this.handleMenuClick("customer")}
                  >
                    <div className="sidebar-link has-arrow">
                      <IconUserBox />
                      <span className="hide-menu">Customers</span>
                    </div>
                    <div aria-expanded="false" className="collapse first-level">
                      {this.checkUserPermisison(["other_profile_customer"]) && (
                        <Link
                          className="first-level__link"
                          to="/tms/customer"
                          onClick={() =>
                            this.setState({
                              selected: "customer",
                              currentUrl: "/tms/customer",
                            })
                          }
                          activeclassname={"active"}
                        >
                          Customer Profile
                        </Link>
                      )}
                      {this.checkUserPermisison([
                        "other_customer_rate",
                        "other_dynamic_pricing",
                        "other_customer_discount"
                      ]) && (
                        <Link
                          className="first-level__link"
                          to="/tms/load-price-settings"
                          onClick={() =>
                            this.setState({
                              selected: "customer",
                              currentUrl: "/tms/load-price-settings",
                            })
                          }
                          activeclassname={"active"}
                        >
                          Customer Rates
                        </Link>

                      )}
                      {this.checkUserPermisison(["other_group_customer"]) && (
                        <Link
                          className="first-level__link"
                          to="/tms/FleetCustomer"
                          onClick={() =>
                            this.setState({
                              selected: "customer",
                              currentUrl: "/tms/FleetCustomer",
                            })
                          }
                          activeclassname={"active"}
                        >
                          Group Customer
                        </Link>
                      )}
                    </div>
                  </div>
                )
                //#endregion Customer
              }

              {
                //#region REPORT
                (this.checkUserPermisison([
                  "reports_customer_revenue",
                  "reports_aging",
                  "reports_driver_revenue",
                  "reports_status_driver",
                  "reports_clock_report",
                  "reports_master_load-master-report",
                  "reports",
                  "reports_leg_type",
                  "reports_forecast_report",
                  "reports_admin_dashboard",
                  "reports_admin_dashboard_2",
                  "reports_productivity_report",
                  "reports_charge_report",
                  "reports_charge_report_3",
                  "reports_loads_report",
                  "reports_load_count",
                  "reports_vessel_report",
                  "reports_chassis_history",
                  "reports_pricing_breakdown",
                  "reports_summary_report",
                  "reports_revenue_report",
                  "reports_driver_pay",
                  "reports_driver_pay_summary",
                  "reports_lfd_report",
                  "reports_return_report",
                  "reports_new_driver_revenue",
                  "reports_loads_report_pricing",
                  "reports_charge_report_2",
                  "reports_import_charge",
                  "reports_export_charge",
                  "reports_profitability_report",
                  "reports_clock_in_out"
                ]) ||
                  (this.state.acl && this.state.acl.includes("customer")) ||
                  (this.state.user &&
                    this.state.user.role === "fleetcustomer")) && (
                  <div
                    className={`sidebar-item ${
                      this.state.selected === "reports" ? "active" : ""
                    } ${
                      this.state.isMenuClicked === "reports" ? "isclicked" : ""
                    }`}
                    onClick={() => this.handleMenuClick("reports")}
                  >
                    <div className="sidebar-link has-arrow">
                      <IconHeartRate />
                      <span className="hide-menu">Reports</span>
                    </div>
                    <div aria-expanded="false" className="collapse first-level">
                      {(this.checkUserPermisison(["reports_aging",
                  "reports"]) ||
                        (this.state.acl &&
                          this.state.acl.includes("customer")) ||
                        (this.state.user &&
                          this.state.user.role === "fleetcustomer")) && (
                        <Link
                          className="first-level__link"
                          to="/tms/report/aging1"
                          onClick={() => {
                            this.setState({
                              selected: "reports",
                              currentUrl: "/tms/report/aging1",
                            });
                          }}
                          activeclassname={"active"}
                        >
                          Aging
                        </Link>
                      )}
                      {(this.checkUserPermisison([
                        "reports_master_load-master-report",
                        "reports"
                      ]) ||
                        (this.state.acl &&
                          this.state.acl.includes("customer")) ||
                        (this.state.user &&
                          this.state.user.role === "fleetcustomer")) && (
                        <Link
                          className="first-level__link"
                          to="/tms/report/load-master-report"
                          onClick={() => {
                            this.setState({
                              selected: "reports",
                              currentUrl: "/tms/report/load-master-report",
                            });
                          }}
                          activeclassname={"active"}
                        >
                          Load Master Report
                        </Link>
                      )}
                      
                      {(this.checkUserPermisison(["reports", "reports_admin_dashboard"]) ||
                        (this.state.acl &&
                          this.state.acl.includes("customer")) ||
                        (this.state.user &&
                          this.state.user.role === "fleetcustomer")) && (
                        <Link
                          className="first-level__link"
                          to="/tms/report/agingChart"
                          onClick={() => {
                            this.setState({
                              selected: "reports",
                              currentUrl: "/tms/report/agingChart",
                            });
                          }}
                          activeclassname={"active"}
                        >
                          Admin Dashboard
                        </Link>
                      )}
                      {(this.checkUserPermisison(["reports", "reports_admin_dashboard_2"]) ||
                        (this.state.acl &&
                          this.state.acl.includes("customer")) ||
                        (this.state.user &&
                          this.state.user.role === "fleetcustomer")) && (
                        <Link
                          className="first-level__link"
                          to="/tms/report/reportDashboard"
                          onClick={() => {
                            this.setState({
                              selected: "reports",
                              currentUrl: "/tms/report/reportDashboard",
                            });
                          }}
                          activeclassname={"active"}
                        >
                          Admin Dashboard 2
                        </Link>
                      )}
                      {this.checkUserPermisison(["reports_clock_report",
                  "reports"]) && (
                        <Link
                          className="first-level__link"
                          to="/tms/report/driverclockinoutreport"
                          onClick={() => {
                            this.setState({
                              selected: "reports",
                              currentUrl: "/tms/report/driverclockinoutreport",
                            });
                          }}
                          activeclassname={"active"}
                        >
                          Clock Report
                        </Link>
                      )}
                      {this.checkUserPermisison(["reports_charge_report","reports"]) && (
                      <Link
                        className="first-level__link"
                        to="/tms/report/report1"
                        onClick={() => {
                          this.setState({
                            selected: 'reports',
                            currentUrl: "/tms/report/report1",
                          });
                        }}
                        activeclassname={"active"}
                      >
                        Charge Report
                      </Link>
                      )}
                      {this.checkUserPermisison(["reports", "reports_charge_report_2"]) && (
                      <Link
                        className="first-level__link"
                        to="/tms/report/charge-report-2"
                        onClick={() => {
                          this.setState({
                            selected: 'reports',
                            currentUrl: "/tms/report/charge-report-2",
                          });
                        }}
                        activeclassname={"active"}
                      >
                        Charge Report 2
                      </Link>
                      )}
                      {this.checkUserPermisison(["reports", "reports_charge_report_3"]) && (
                      <Link
                        className="first-level__link"
                        to="/tms/report/charge-3"
                        onClick={() => {
                          this.setState({
                            selected: 'reports',
                            currentUrl: "/tms/report/charge-3",
                          });
                        }}
                        activeclassname={"active"}
                      >
                        Charge Report 3
                      </Link>
                      )}
                      {(this.checkUserPermisison([
                        "reports_customer_revenue",
                        "reports"
                      ]) ||
                        (this.state.acl &&
                          this.state.acl.includes("customer")) ||
                        (this.state.user &&
                          this.state.user.role === "fleetcustomer")) && (
                        <Link
                          className="first-level__link"
                          to="/tms/report/revenue"
                          onClick={() => {
                            this.setState({
                              selected: "reports",
                              currentUrl: "/tms/report/revenue",
                            });
                          }}
                          activeclassname={"active"}
                        >
                          Customer Revenue
                        </Link>
                      )}
                      {this.state.acl &&
                        !this.state.acl.includes("customer") &&
                        this.state.user &&
                        this.checkUserPermisison(["reports", "reports_driver_pay"]) && (
                          <Link
                            className="first-level__link"
                            to="/tms/report/driver-pay-report"
                            onClick={() =>
                              this.setState({
                                selected: "reports",
                                currentUrl: "/tms/report/driver-pay-report",
                              })
                            }
                            activeclassname={"active"}
                          >
                            Driver Pay Report
                          </Link>
                        )}
                         {this.checkUserPermisison(["reports", "reports_driver_pay_summary"]) && ['carrier', 'fleetmanager'].includes(this.state.user.role) &&(
                          <Link
                            className="first-level__link"
                            to="/tms/report/driver-pay-summary-report"
                            onClick={() =>
                              this.setState({
                                selected: "reports",
                                currentUrl: "/tms/report/driver-pay-summary-report",
                              })
                            }
                            activeClassName={"active"}
                          >
                            Driver Pay Summary Report
                          </Link>
                        )}
                      {this.checkUserPermisison(["reports_driver_revenue","reports"]) && (
                        <Link
                          className="first-level__link"
                          to="/tms/report/driverrevenue"
                          onClick={() => {
                            this.setState({
                              selected: "reports",
                              currentUrl: "/tms/report/driverrevenue",
                            });
                          }}
                          activeclassname={"active"}
                        >
                          Driver Revenue
                        </Link>
                      )}
                      {(this.checkUserPermisison(["reports", "reports_forecast_report"]) ||
                        (this.state.acl &&
                          this.state.acl.includes("customer")) ||
                        (this.state.user &&
                          this.state.user.role === "fleetcustomer")) && (
                        <Link
                          className="first-level__link"
                          to="/tms/report/ForcastReport"
                          onClick={() => {
                            this.setState({
                              selected: "reports",
                              currentUrl: "/tms/report/ForcastReport",
                            });
                          }}
                          activeclassname={"active"}
                        >
                          Forecast Report
                        </Link>
                      )}
                      {this.checkUserPermisison(["reports", "reports_new_driver_revenue"]) && (
                        <Link
                          className="first-level__link"
                          to="/tms/report/newdriverrevenue"
                          onClick={() => {
                            this.setState({
                              selected: "reports",
                              currentUrl: "/tms/report/newdriverrevenue",
                            });
                          }}
                          activeclassname={"active"}
                        >
                          New Driver Revenue
                        </Link>
                      )}
                      {(this.checkUserPermisison(["reports", "reports_leg_type"]) ||
                        (this.state.acl &&
                          this.state.acl.includes("customer")) ||
                        (this.state.user &&
                          this.state.user.role === "fleetcustomer")) && (
                        <Link
                          className="first-level__link"
                          to="/tms/report/leg-type-report"
                          onClick={() => {
                            this.setState({
                              selected: "reports",
                              currentUrl: "/tms/report/leg-type-report",
                            });
                          }}
                          activeclassname={"active"}
                        >
                          Leg Type Report
                        </Link>
                      )}
                      {this.checkUserPermisison(["reports", "reports_lfd_report"]) && (
                      <Link
                        className="first-level__link"
                        to="/tms/report/lfd-report"
                        onClick={() =>
                          this.setState({
                            selected: "reports",
                            currentUrl: "/tms/report/lfd-report",
                          })
                        }
                        activeclassname={"active"}
                      >
                        LFD Report
                      </Link>
                      )}
                      {this.checkUserPermisison(["reports", "reports_loads_report"]) && (
                      <Link
                        className="first-level__link"
                        to="/tms/report/report2"
                        onClick={() => {
                          this.setState({
                            selected: "reports",
                            currentUrl: "/tms/report/report2",
                          });
                        }}
                        activeclassname={"active"}
                      >
                        Loads Report
                      </Link>
                      )}
                      {this.checkUserPermisison(["reports", "reports_loads_report_pricing"]) && (
                      <Link
                        className="first-level__link"
                        to="/tms/report/pricing-load-report"
                        onClick={() => {
                          this.setState({
                            selected: "reports",
                            currentUrl: "/tms/report/pricing-load-report",
                          });
                        }}
                        activeclassname={"active"}
                      >
                        Loads Report Pricing
                      </Link>
                      )}
                      {this.checkUserPermisison(["reports", "reports_load_count"]) && (
                      <Link
                        className="first-level__link"
                        to="/tms/report/report3"
                        onClick={() => {
                          this.setState({
                            selected: "reports",
                            currentUrl: "/tms/report/report3",
                          });
                        }}
                        activeclassname={"active"}
                      >
                        Load Count
                      </Link>
                      )}
                      {this.checkUserPermisison(["reports", "reports_pricing_breakdown"]) && (
                      <Link
                        className="first-level__link"
                        to="/tms/report/report5"
                        onClick={() => {
                          this.setState({
                            selected: "reports",
                            currentUrl: "/tms/report/report4",
                          });
                        }}
                        activeclassname={"active"}
                      >
                        Pricing Breakdown
                      </Link>
                      )}
                      {(this.checkUserPermisison(["reports", "reports_productivity_report"]) ||
                        (this.state.acl &&
                          this.state.acl.includes("customer")) ||
                        (this.state.user &&
                          this.state.user.role === "fleetcustomer")) && (
                        <Link
                          className="first-level__link"
                          to="/tms/report/productivityReport"
                          onClick={() => {
                            this.setState({
                              selected: "reports",
                              currentUrl: "/tms/report/productivityReport",
                            });
                          }}
                          activeclassname={"active"}
                        >
                          Productivity Report
                        </Link>
                      )}
                      {this.checkUserPermisison(["reports", "reports_return_report"]) && (
                      <Link
                        className="first-level__link"
                        to="/tms/report/return-report"
                        onClick={() =>
                          this.setState({
                            selected: "reports",
                            currentUrl: "/tms/report/return-report",
                          })
                        }
                        activeclassname={"active"}
                      >
                        Return Report
                      </Link>
                      )}
                      {this.checkUserPermisison(["reports", "reports_revenue_report"]) && (
                      <Link
                        className="first-level__link"
                        to="/tms/report/revenue-report"
                        onClick={() =>
                          this.setState({
                            selected: "reports",
                            currentUrl: "/tms/report/revenue-report",
                          })
                        }
                        activeclassname={"active"}
                      >
                        Revenue Report
                      </Link>
                      )}
                      {/* )} */}
                      {this.checkUserPermisison(["reports_status_driver",
                  "reports"]) && (
                        <Link
                          className="first-level__link"
                          to="/tms/report/driverstatusreport"
                          onClick={() => {
                            this.setState({
                              selected: "reports",
                              currentUrl: "/tms/report/driverstatusreport",
                            });
                          }}
                          activeclassname={"active"}
                        >
                          Status Driver
                        </Link>
                      )}
                      {this.checkUserPermisison(["reports", "reports_summary_report"]) && (
                      <Link
                        className="first-level__link"
                        to="/tms/report/summary-report"
                        onClick={() =>
                          this.setState({
                            selected: "reports",
                            currentUrl: "/tms/report/summary-report",
                          })
                        }
                        activeclassname={"active"}
                      >
                        Summary Report
                      </Link>
                      )}
                      {this.checkUserPermisison(["reports", "reports_vessel_report"]) && (
                      <Link
                        className="first-level__link"
                        to="/tms/report/report4"
                        onClick={() => {
                          this.setState({
                            selected: "reports",
                            currentUrl: "/tms/report/report4",
                          });
                        }}
                        activeclassname={"active"}
                      >
                        Vessel Report
                      </Link>
                      )}
                      {this.checkUserPermisison(["reports", "reports_profitability_report"]) && (
                      <Link
                        className="first-level__link"
                        to="/tms/report/profitability-report"
                        onClick={() => {
                          this.setState({
                            selected: "reports",
                            currentUrl: "/tms/report/profitability-report",
                          });
                        }}
                        activeclassname={"active"}
                      >
                        Profitability Report
                      </Link>
                      )}
                      {this.checkUserPermisison(["reports", "reports_chassis_history"]) &&
                        getStorage("currentUserRole") !== "customer" && (
                          <Link
                            className="first-level__link"
                            to="/tms/report/chassishistory"
                            onClick={() => {
                              this.setState({
                                selected: "reports",
                                currentUrl: "/tms/report/chassishistory",
                              });
                            }}
                            activeClassName={"active"}
                          >
                            Chassis History
                          </Link>
                          )
                      }
                      {this.checkUserPermisison(["reports", "reports_clock_in_out"]) && (
                      <Link
                        className="first-level__link"
                        to="/tms/report/clock-in-clock-out-report"
                        onClick={() => {
                          this.setState({
                            selected: "reports",
                            currentUrl: "/tms/report/clock-in-clock-out-report",
                          });
                        }}
                        activeClassName={"active"}
                      >
                        ClockIn-ClockOut Report
                      </Link>
                      )}
                      {this.checkUserPermisison(["reports", "reports_external_charge_report"]) && (
                      <Link
                        className="first-level__link"
                        to="/tms/report/external-charge"
                        onClick={() => {
                          this.setState({
                            selected: "reports",
                            currentUrl: "/tms/report/external-charge",
                          });
                        }}
                        activeclassname={"active"}
                      >
                        External Charge
                      </Link>
                      )}
                      {
                        // Import Charge Reports for DHE Account
                          configuration.idForCustomChargeReport.indexOf(
                            carrierId
                          ) > -1 && this.checkUserPermisison(["reports", "reports_import_charge"]) && (
                            <Link
                              className="first-level__link"
                              to="/tms/report/import-charge-report"
                              onClick={() => {
                                this.setState({
                                  selected: "reports",
                                  currentUrl:
                                    "/tms/report/import-charge-report",
                                });
                              }}
                              activeclassname={"active"}
                            >
                              Import Charge Report
                            </Link>
                          )
                      }
                      {
                        // Export Charge Reports for DHE Account
                          configuration.idForCustomChargeReport.indexOf(
                            carrierId
                          ) > -1 && this.checkUserPermisison(["reports", "reports_export_charge"]) && (
                            <Link
                              className="first-level__link"
                              to="/tms/report/export-charge-report"
                              onClick={() => {
                                this.setState({
                                  selected: "reports",
                                  currentUrl:
                                    "/tms/report/export-charge-report",
                                });
                              }}
                              activeclassname={"active"}
                            >
                              Export Charge Report
                            </Link>
                          )
                      }

                      {reports !== null &&
                        this.state.acl &&
                        !this.state.acl.includes("customer") &&
                        reports &&
                        reports
                          .filter((d) => !d.isMain)
                          .map((d, index) => {
                            return (
                              <Link
                                className="first-level__link"
                                to={`/tms/report/customReport/${d.name}`}
                                onClick={() => {
                                  this.setState({
                                    selected: "reports",
                                    currentUrl: "/tms/report/report4",
                                  });
                                }}
                                activeclassname={"active"}
                                key={index}
                              >
                                {d.name}
                              </Link>
                            );
                          })}
                    </div>
                  </div>
                )
                //#endregion
              }
               
              {
                //#region Settings
                this.checkUserPermisison([
                  "settings_group_settings",
                  "settings_general",
                  "other_permission",
                  "other_role_management",
                  "settings_expense",
                  "other_container_owner",
                  "other_container_size",
                  "other_container_type",
                  "other_container_free_day",
                  "other_chassis_owner",
                  "other_chassis_size",
                  "other_chassis_type",
                  "settings_commodity",
                  "settings_load_status_colors",
                  "settings_general_info",
                  "settings_equipment_params",
                  "settings_invoice_setup",
                  "settings_email_configuration",
                  "settings_billing_configuration",
                  "settings_my_apps",
                  "appointment_list",
                  "container-tracking"
                ]) && (
                  <div
                    className={`sidebar-item ${
                      this.state.selected === "setting" ? "active" : ""
                    } ${
                      this.state.isMenuClicked === "setting" ? "isclicked" : ""
                    }`}
                    onClick={() => this.handleMenuClick("setting")}
                  >
                    <div className="sidebar-link has-arrow">
                      <IconSettings />
                      <span className="hide-menu">Settings</span>
                    </div>
                    <div aria-expanded="false" className="collapse first-level">
                      {this.checkUserPermisison(["settings_general"]) && 
                        <Link
                        className="first-level__link"
                        to="/settings/general-setting"
                        onClick={() =>
                          this.setState({
                            selected: "setting",
                            currentUrl: "/settings/general-setting",
                          })
                        }
                        activeclassname={"active"}
                      >
                        General Settings
                      </Link>}

                      {this.checkUserPermisison(["other_permission"]) && (
                        <Link
                          className="first-level__link"
                          to="/carrieraccessmanagement"
                          onClick={() =>
                            this.setState({
                              selected: "setting",
                              currentUrl: "/carrieraccessmanagement",
                            })
                          }
                          activeclassname={"active"}
                        >
                          Users & Permissions
                        </Link>
                      )}
                      {this.checkUserPermisison(["other_role_management"]) &&
                        <Link
                          className="first-level__link"
                          to="/roleaccessmanagement"
                          onClick={() =>
                            this.setState({
                              selected: "setting",
                              currentUrl: "/roleaccessmanagement",
                            })
                          }
                          activeclassname={"active"}
                        >
                          Role Management
                        </Link>
                      }
                      {
                        this.checkUserPermisison(["settings_expense"]) &&
                        <Link
                          className="first-level__link"
                          to="/settings/expense-setting"
                          onClick={() =>
                            this.setState({
                              selected: "setting",
                              currentUrl: "/settings/expense-setting",
                            })
                          }
                          activeclassname={"active"}
                        >
                          Expense
                        </Link>
                      }

                      {this.checkUserPermisison(["other_container_owner", 'other_container_size', 'other_container_type',"other_container_free_day"]) && (
                        <Link
                          className="first-level__link"
                          to="/tms/Container/Owner"
                          onClick={() =>
                            this.setState({
                              selected: "setting",
                              currentUrl: "/tms/Container/Owner",
                            })
                          }
                          activeclassname={"active"}
                        >
                          Container Settings
                        </Link>
                      )}
                      {this.checkUserPermisison(["other_chassis_owner", "other_chassis_size", "other_chassis_type",]) && (
                      <Link
                        className="first-level__link"
                        to="/tms/Chassis/Owner"
                        onClick={() =>
                          this.setState({
                            selected: "setting",
                            currentUrl: "/tms/Chassis/Owner",
                          })
                        }
                        activeclassname={"active"}
                      >
                        Chassis Settings
                      </Link>
                     )} 
                      {this.checkUserPermisison(["settings_commodity"]) && (
                        <Link
                          className="first-level__link"
                          to="/settings/Commodity"
                          onClick={() =>
                            this.setState({
                              selected: "setting",
                              currentUrl: "/settings/Commodity",
                            })
                          }
                          activeclassname={"active"}
                        >
                          Commodity Settings
                        </Link>
                      )}
                      {this.checkUserPermisison(["settings_terminal"]) && 
                      getStorage("currentUserRole") == "carrier" &&
                        configuration.idForTerminal.indexOf(
                          getStorage("currentUserID")
                        ) != -1 && (
                          <Link
                            className="first-level__link"
                            to="/tms/terminals"
                            onClick={() =>
                              this.setState({
                                selected: "setting",
                                currentUrl: "/tms/terminals",
                              })
                            }
                            activeclassname={"active"}
                          >
                            Terminal Settings
                          </Link>
                        )}
                      {this.checkUserPermisison(["settings_load_status_colors"]) && 
                        <Link
                          className="first-level__link"
                          to="/settings/loadStatusColors"
                          onClick={() =>
                            this.setState({
                              selected: "setting",
                              currentUrl: "/settings/loadStatusColors",
                            })
                          }
                          activeclassname={"active"}
                        >
                          Dispatch Color Settings
                        </Link>
                      }
                      {
                        this.checkUserPermisison(["settings_group_settings"]) && 
                        <Link
                          className="first-level__link"
                          to="/settings/group-setting"
                          onClick={() =>
                            this.setState({
                              selected: "setting",
                              currentUrl: "/settings/group-setting",
                            })
                          }
                          activeclassname={"active"}
                        >
                          Group Settings
                        </Link>
                      }

                      {
                        this.checkUserPermisison(["settings_general_info"]) && 
                        <Link
                          className="first-level__link"
                          to="/settings/general-info"
                          onClick={() =>
                            this.setState({
                              selected: "setting",
                              currentUrl: "/settings/general-info",
                            })
                          }
                          activeclassname={"active"}
                        >
                          General Info
                        </Link>
                      }
                      {
                        this.checkUserPermisison(["settings_equipment_params"]) && 
                        <Link
                          className="first-level__link"
                          to="/account/equipment-parameters"
                          onClick={() =>
                            this.setState({
                              selected: "setting",
                              currentUrl: "/account/equipment-parameters",
                            })
                          }
                          activeclassname={"active"}
                        >
                          Equipment Parameters
                        </Link>
                      
                      }    
                      {
                        this.checkUserPermisison(["settings_invoice_setup"]) && 
                        <Link
                          className="first-level__link"
                          to="/account/invoice-setup"
                          onClick={() =>
                            this.setState({
                              selected: "setting",
                              currentUrl: "/account/invoice-setup",
                            })
                          }
                          activeclassname={"active"}
                        >
                          Document Configuration
                        </Link>
                      }

                      { 
                        this.checkUserPermisison(["settings_email_configuration"]) && 
                          <Link
                            className="first-level__link"
                            to="/account/email-configuration"
                            onClick={() =>
                              this.setState({
                                selected: "setting",
                                currentUrl: "/account/email-configuration",
                              })
                            }
                            activeclassname={"active"}
                          >
                            Email Configuration
                          </Link>
                      }
                        {["carrier"].includes(this.state.user.role) && 
                        this.checkUserPermisison(["settings_billing_configuration"]) && 
                          <Link
                            className="first-level__link"
                            to="/account/billing-configuration"
                            onClick={() =>
                              this.setState({
                                selected: "setting",
                                currentUrl: "/account/billing-configuration",
                              })
                            }
                            activeClassName={"active"}
                          >
                         
                            Billing Configuration
                          </Link>
                      }
                      { ["carrier", "fleetmanager"].includes(this.state.user.role) &&
                        this.checkUserPermisison(["settings_developer"]) && 
                          <Link
                            className="first-level__link"
                            to="/settings/developer-settings"
                            onClick={() =>
                              this.setState({
                                selected: "setting",
                                currentUrl: "/settings/developer-settings",
                              })
                            }
                            activeClassName={"active"}
                          >
                            Developer Settings
                          </Link>
                      }
                       { ["carrier"].includes(this.state.user.role) &&
                        this.checkUserPermisison(["settings_my_apps"]) && 
                          <Link
                            className="first-level__link"
                            to="/settings/my-apps"
                            onClick={() =>
                              this.setState({
                                selected: "setting",
                                currentUrl: "/settings/my-apps",
                              })
                            }
                            activeClassName={"active"}
                          >
                            My Apps
                          </Link>
                      }
                      {this.checkUserPermisison(["appointment_list"]) &&
                        <Link
                          className="first-level__link"
                          to="/tms/AppointmentList"
                          onClick={() =>
                            this.setState({
                              selected: "setting",
                              currentUrl: "/tms/AppointmentList",
                            })
                          }
                          activeclassname={"active"}
                        >
                          Appointment List
                        </Link>
                      }
                      {this.checkUserPermisison(["container-tracking"]) && (
                        <Link
                          className="first-level__link"
                          to="/container-tracking"
                          onClick={() =>
                            this.setState({
                              selected: "setting",
                              currentUrl: "/container-tracking",
                            })
                          }
                          activeclassname={"active"}
                        >
                          Container Tracking
                        </Link>
                      )}
                    </div>
                  </div>
                )
                //#endregion
              }

               {/*Admin Menu*/} 
              {this.state.user && this.state.user.role == "admin" && (
                <React.Fragment>
                  <div
                    className={`sidebar-item ${this.state.currentUrl == "/admin/company-tms"
                      ? "selected"
                      : ""
                      }`}
                  >
                    <Link
                      className="sidebar-link waves-effect waves-dark sidebar-link"
                      to="/admin/company-tms"
                      onClick={() =>
                        this.setState({
                          selected: 3,
                          currentUrl: "/admin/company-tms"
                        })
                      }
                      activeclassname={"active"}
                    >
                      <IconUserAlt />
                      <span className="hide-menu">Company</span>
                    </Link>
                  </div>
                  <div className={`sidebar-item ${this.state.currentUrl == '/admin/dispatcher' ? 'selected' : ''}`}>
                    <Link className="sidebar-link waves-effect waves-dark sidebar-link" to="/admin/dispatcher" onClick={() => this.setState({ selected: 2, currentUrl: "/admin/dispatcher" })} activeclassname={"active"} >
                      <IconMonitor />
                      <span className="hide-menu"> Dispatcher </span>
                    </Link>
                  </div>
                  <div className={`sidebar-item ${this.state.currentUrl == '/admin/account-receivable' ? 'selected' : ''}`}>
                    <Link className="sidebar-link waves-effect waves-dark sidebar-link" to="/admin/account-receivable" onClick={() => this.setState({ selected: 3, currentUrl: "/admin/account-receivable" })} activeclassname={"active"} >
                    <IconBilling />
                      <span className="hide-menu"> Accounts Receivable </span>
                    </Link></div>
                  <div className={`sidebar-item ${this.state.currentUrl == '/admin/subaccount-receivable' ? 'selected' : ''}`}>
                    <Link className="sidebar-link waves-effect waves-dark sidebar-link" to="/admin/subaccount-receivable" onClick={() => this.setState({ selected: 4, currentUrl: "/admin/subaccount-receivable" })} activeclassname={"active"} >
                    <IconBilling />
                      <span className="hide-menu"> Sub Accounts Receivable </span>
                    </Link></div>
                  <div className={`sidebar-item ${this.state.currentUrl == '/admin/locked-accounts' ? 'selected' : ''}`}>
                    <Link className="sidebar-link waves-effect waves-dark sidebar-link" to="/admin/locked-accounts" onClick={() => this.setState({ selected: 5, currentUrl: "/admin/locked-accounts" })} activeclassname={"active"} >
                      <i className="uil uil-lock" />
                      <span className="hide-menu">Locked Accounts</span>
                    </Link></div>
                  <div className={`sidebar-item ${this.state.currentUrl == '/admin/short-name' ? 'selected' : ''}`}>
                    <Link className="sidebar-link waves-effect waves-dark sidebar-link" to="/admin/short-name" onClick={() => this.setState({ selected: 6, currentUrl: "/admin/short-name" })} activeclassname={"active"} >
                      <i className="uil uil-building" />
                      <span className="hide-menu">Short Name</span>
                    </Link></div>
                  <div className={`sidebar-item ${this.state.currentUrl == '/admin/PreRegisterUsers' ? 'selected' : ''}`}>
                    <Link className="sidebar-link waves-effect waves-dark sidebar-link" to="/admin/PreRegisterUsers" onClick={() => this.setState({ selected: 7, currentUrl: "/admin/PreRegisterUsers" })} activeclassname={"active"} >
                      <i className="uil uil-building" />
                      <span className="hide-menu">New Companies</span>
                    </Link></div>
                  <div className={`sidebar-item ${this.state.currentUrl == '/admin/customers' ? 'selected' : ''}`}>
                    <Link className="sidebar-link waves-effect waves-dark sidebar-link" to="/admin/customers" onClick={() => this.setState({ selected: 11, currentUrl: "/admin/customers" })} activeclassname={"active"} >
                      <i className="uil uil-users-alt" />
                      <span className="hide-menu">Customer</span>
                    </Link></div>
                  <div className={`sidebar-item ${
                      this.state.selected === "admin-chassis" ? "active" : ""
                    } ${
                      this.state.isMenuClicked === "admin-chassis"
                        ? "isclicked"
                        : ""
                    }`}
                    onClick={() => this.handleMenuClick("admin-chassis")}
                    >
                    <div
                      className="sidebar-link has-arrow"
                      // href="javascript:void(0)"
                      aria-expanded="false">
                      <i className="uil uil-calendar-alt" />
                      <span className="hide-menu">Chassis</span>
                    </div>
                    <div aria-expanded="false" className="collapse first-level">
                      
                        <Link
                          className="first-level__link"
                          to="/admin/chassis/owner"
                          onClick={() =>
                            this.setState({
                              selected: "admin-chassis",
                              currentUrl: "/admin/chassis/owner"
                            })
                          }
                          activeclassname={"active"}>
                          Owner
                        </Link>
                    
                        <Link
                          className="first-level__link"
                          to="/admin/chassis/Type"
                          onClick={() =>
                            this.setState({
                              selected: "admin-chassis",
                              currentUrl: "/admin/chassis/type"
                            })
                          }
                          activeclassname={"active"}>
                          Type
                        </Link>
                    
                        <Link
                          className="first-level__link"
                          to="/admin/chassis/Size"
                          onClick={() =>
                            this.setState({
                              selected: "admin-chassis",
                              currentUrl: "/admin/chassis/size"
                            })
                          }
                          activeclassname={"active"}>
                          Size
                        </Link>
               
                    </div>
                  </div>
                  <div  className={`sidebar-item ${
                        this.state.selected === "admin-container" ? "active" : ""
                      } ${
                        this.state.isMenuClicked === "admin-container"
                          ? "isclicked"
                          : ""
                      }`}
                      onClick={() => this.handleMenuClick("admin-container")}>
                    <div className="sidebar-link has-arrow" >
                      <i className="uil uil-calendar-alt" />
                      <span className="hide-menu">Container</span>
                    </div>
                    <div aria-expanded="false" className="collapse first-level">
                   
                        <Link
                          className="first-level__link"
                          to="/admin/container/type"
                          onClick={() =>
                            this.setState({
                              selected: 'admin-container',
                              currentUrl: "/admin/container/type"
                            })
                          }
                          activeclassname={"active"}>
                          Type
                        </Link>
                     
                        <Link
                          className="first-level__link"
                          to="/admin/container/size"
                          onClick={() =>
                            this.setState({
                              selected: 'admin-container',
                              currentUrl: "/admin/container/size"
                            })
                          }
                          activeclassname={"active"}>
                          Size
                        </Link>
                     
                        <Link
                          className="first-level__link"
                          to="/admin/container/owner"
                          onClick={() =>
                            this.setState({
                              selected: 'admin-container',
                              currentUrl: "/admin/container/owner"
                            })
                          }
                          activeclassname={"active"}>
                          Owner
                        </Link>
                   
                    </div>
                  </div>
                </React.Fragment>
              )}
             {this.state.user && this.state.user.role == "admin" &&(
               <React.Fragment>
               <li className={`sidebar-item ${this.state.selected == 'support' ? 'selected'  : ""}`} id="support">
                 <Link
                   className={`sidebar-link sidebar-link pointer ${this.state.selected == 'support' ? 'active'  : ""}`}
                   to="/admin/account-status"
                   onClick={() =>
                    this.setState({
                      selected: 'support',
                      currentUrl: "/admin/account-status"
                    })
                  }
                  activeClassName={"active"}
                 >
                   <IconUserAlt />
                   <span className="hide-menu">Account Status</span>
                 </Link>
               </li>
                <li
                  className={`sidebar-item ${this.state.selected == 'alertSystem' ? 'selected'  : ""}`} id="alertSystem"
                >
                  <Link
                    className={`sidebar-link sidebar-link pointer ${this.state.selected == 'alertSystem' ? 'active'  : ""}`}
                  
                    to="/admin/alertSystem"
                    onClick={() =>
                      this.setState({ selected: 'alertSystem', currentUrl: "/admin/alertSystem" })
                    }
                    activeClassName={"active"}
                  >
                    <i className="uil uil-envelope-exclamation"></i>
                    <span className="hide-menu">Alert System</span>
                  </Link>
                </li>
                <li
                className={`sidebar-item ${this.state.selected== 'liveVideoSource' ? 'selceted' : ""}`} id="liveVideoSource"
                >
                <Link
                className={`sidebar-item sidebar-link pointer ${this.state.selected == 'liveVideoSource' ? 'active' : ""}`}
                to="/admin/liveVideoSource"
                onClick={()=>
                  this.setState({ selected : 'liveVideSource', currentUrl: "/admin/liveVideoSource"})
                }
                activeClassName = {"active"}
                >
                  <i className="uil uil-video"></i>
                  <span className="hide-menu">Live Video Source</span>
                </Link>
                </li>
               {/* <li className="sidebar-item">
                   <span className="hide-menu sidebar-v-no">V. {config.version}</span>
               </li> */}
             </React.Fragment>
             )}

             {this.state.user && this.state.user.role == "admin" &&(
               <React.Fragment>
               <li className={`sidebar-item ${this.state.selected == 'support' ? 'selected'  : ""}`} id="support">
                 <Link
                   className={`sidebar-link sidebar-link pointer ${this.state.selected == 'support' ? 'active'  : ""}`}
                   to="/admin/emailAuditReport"
                   onClick={() =>
                    this.setState({
                      selected: 'support',
                      currentUrl: "/admin/account-status"
                    })
                  }
                  activeClassName={"active"}
                 >
                   <IconUserAlt />
                   <span className="hide-menu">Mail Audit Report</span>
                 </Link>
               </li>
                <li
                  className={`sidebar-item ${this.state.selected == 'alertSystem' ? 'selected'  : ""}`} id="alertSystem"
                >
                  <Link
                    className={`sidebar-link sidebar-link pointer ${this.state.selected == 'alertSystem' ? 'active'  : ""}`}
                  
                    to="/admin/alertSystem"
                    onClick={() =>
                      this.setState({ selected: 'alertSystem', currentUrl: "/admin/alertSystem" })
                    }
                    activeClassName={"active"}
                  >
                    <i className="uil uil-envelope-exclamation"></i>
                    <span className="hide-menu">Alert System</span>
                  </Link>
                </li>
                <li
                  className={`sidebar-item ${this.state.selected == 'currency' ? 'selected'  : ""}`} id="currency"
                >
                  <Link
                    className={`sidebar-link sidebar-link pointer ${this.state.selected == 'currency' ? 'active'  : ""}`}

                    to="/admin/currency"
                    onClick={() =>
                      this.setState({ selected: 'currency', currentUrl: "/admin/currency" })
                    }
                    activeClassName={"active"}
                  >
                    <IconPayment />
                    <span className="hide-menu">Currency</span>
                  </Link>
                </li>
               {/* <li className="sidebar-item">
                   <span className="hide-menu sidebar-v-no">V. {config.version}</span>
               </li> */}
             </React.Fragment>
             )}

              {
                //#region Learnings
                (this.state.user.role === "admin" || this.state.user.role=='carrier' || this.state.user.role ==='fleetmanager') &&
                <LearningMenu
                state ={this.state}
                handleMenuClick={this.handleMenuClick}
                setState={this.setState.bind(this)}
                ></LearningMenu>
              }
              {/* system logger */}
              {
                //#region system logger
                (this.state.user.role=='carrier' || this.state.user.role ==='fleetmanager') &&
                <li
                  className={`sidebar-item ${this.state.selected == 'systemlog' ? 'selected'  : ""}`} id="systemlog"
                >
                  <Link
                    className={`sidebar-link sidebar-link pointer ${this.state.selected == 'systemlog' ? 'active'  : ""}`}
                  
                    to="/tms/systemlogs"
                    onClick={() =>
                      this.setState({ selected: 'systemlog', currentUrl: "/tms/systemlogs" })
                    }
                    activeClassName={"active"}
                  >
                    <SystemLogIcon/>
                    <span className="hide-menu">System Log</span>
                  </Link>
                </li>
              }
              
              
              {
                //#region LOGOUT
                this.state.user && (
                  <React.Fragment>
                    <li className="sidebar-item" id="logout">
                      <LogoutButton handleClick={this.logout}/>
                    </li>
                    {/* <LogoutButton/> */}
                    {/* <li className="sidebar-item">
                        <span className="hide-menu sidebar-v-no">V. {config.version}</span>
                    </li> */}
                  </React.Fragment>
                )
                //# end region
              }
              <div className="poweredby mt-5 flex-column text-center">
                <span className="poweredby__text mr-1 mb-1 font-14">Powered by</span>
                <svg
                  className={`cicon poweredby__logo`}
                  width="142"
                  height="20"
                  viewBox="0 0 142 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M30.2165 20C28.1835 20 26.3429 19.5879 24.722 18.7088C23.1011 17.8571 21.8374 16.6758 20.9033 15.1374C19.9692 13.6264 19.5297 11.9231 19.5297 10C19.5297 8.1044 19.9692 6.4011 20.9033 4.86264C21.8374 3.35165 23.1011 2.17033 24.722 1.29121C26.3429 0.439559 28.1835 0 30.2165 0C32.2495 0 34.0627 0.439559 35.6835 1.29121C37.3044 2.17033 38.5681 3.35165 39.5022 4.86264C40.4363 6.4011 40.9033 8.1044 40.9033 10C40.9033 11.9231 40.4363 13.6264 39.5022 15.1374C38.5681 16.6758 37.3044 17.8571 35.6835 18.7088C34.0627 19.5879 32.2495 20 30.2165 20ZM30.2165 15.4945C31.178 15.4945 32.0572 15.2747 32.8539 14.8077C33.6231 14.3681 34.255 13.7088 34.722 12.8846C35.1616 12.0604 35.4088 11.0989 35.4088 10C35.4088 8.92857 35.1616 7.96703 34.722 7.14285C34.255 6.31868 33.6231 5.65934 32.8539 5.19231C32.0572 4.75275 31.178 4.50549 30.2165 4.50549C29.2275 4.50549 28.3484 4.75275 27.5791 5.19231C26.7824 5.65934 26.1506 6.31868 25.711 7.14285C25.244 7.96703 25.0242 8.92857 25.0242 10C25.0242 11.0989 25.244 12.0604 25.711 12.8846C26.1506 13.7088 26.7824 14.3681 27.5791 14.8077C28.3484 15.2747 29.2275 15.4945 30.2165 15.4945ZM13.5107 1.12639C14.7921 1.71139 15.795 2.54711 16.5193 3.63353C17.2157 4.71996 17.5779 6.00139 17.5779 7.44996C17.5779 8.92639 17.2157 10.2078 16.5193 11.2664C15.795 12.3528 14.7921 13.1885 13.5107 13.7735C12.2014 14.3585 10.6693 14.6371 8.91429 14.6371H5.51571V19.735H0V10.2914H8.58C9.69428 10.2914 10.5579 10.0685 11.1429 9.5671C11.7 9.06568 12.0064 8.36925 12.0064 7.44996C12.0064 6.55853 11.7 5.83425 11.1429 5.33282C10.5579 4.83139 9.69428 4.58068 8.58 4.58068H0V0.234961H8.91429C10.6693 0.234961 12.2014 0.54139 13.5107 1.12639ZM57.3238 13.5714C58.5051 12.9945 59.4392 12.1978 60.0985 11.1538C60.7578 10.1099 61.0875 8.9011 61.0875 7.5C61.0875 6.07143 60.7304 4.8077 60.0435 3.73627C59.3293 2.66484 58.3403 1.84066 57.0765 1.26374C55.7853 0.686817 54.2743 0.384619 52.5436 0.384619H43.7523V4.67033H52.2139C53.3128 4.67033 54.1644 4.91759 54.7414 5.41209C55.2908 5.9066 55.593 6.62088 55.593 7.5C55.593 8.4066 55.2908 9.09341 54.7414 9.58792C54.1644 10.0824 53.3128 10.3022 52.2139 10.3022H43.7523V19.6154H49.1919V14.5055H52.1589L55.6479 19.6154H61.4721L57.3238 13.5714ZM67.9136 19.6154V4.69781H62.007V0.384619H79.2323V4.69781H73.3532V19.6154H67.9136Z"
                    fill="var(--color-sidebarmenulink-normal)"
                  />
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M131.253 20C129.22 20 127.38 19.5879 125.759 18.7088C124.138 17.8571 122.874 16.6758 121.94 15.1374C121.006 13.6264 120.566 11.9231 120.566 10C120.566 8.1044 121.006 6.4011 121.94 4.86264C122.874 3.35165 124.138 2.17033 125.759 1.29121C127.38 0.439559 129.22 0 131.253 0C133.286 0 135.099 0.439559 136.72 1.29121C138.341 2.17033 139.605 3.35165 140.539 4.86264C141.473 6.4011 141.94 8.1044 141.94 10C141.94 11.9231 141.473 13.6264 140.539 15.1374C139.605 16.6758 138.341 17.8571 136.72 18.7088C135.099 19.5879 133.286 20 131.253 20ZM131.253 15.4945C132.215 15.4945 133.094 15.2747 133.891 14.8077C134.66 14.3681 135.292 13.7088 135.759 12.8846C136.198 12.0604 136.446 11.0989 136.446 10C136.446 8.92857 136.198 7.96703 135.759 7.14285C135.292 6.31868 134.66 5.65934 133.891 5.19231C133.094 4.75275 132.215 4.50549 131.253 4.50549C130.264 4.50549 129.385 4.75275 128.616 5.19231C127.819 5.65934 127.187 6.31868 126.748 7.14285C126.281 7.96703 126.061 8.92857 126.061 10C126.061 11.0989 126.281 12.0604 126.748 12.8846C127.187 13.7088 127.819 14.3681 128.616 14.8077C129.385 15.2747 130.264 15.4945 131.253 15.4945ZM97.55 3.73627C96.8357 2.66484 95.8467 1.84066 94.583 1.26374C93.2918 0.686817 91.7808 0.384619 90.05 0.384619H81.2588V4.67033H89.7203C90.8192 4.67033 91.6709 4.91759 92.2478 5.41209C92.7973 5.9066 93.0995 6.62088 93.0995 7.5C93.0995 8.4066 92.7973 9.09341 92.2478 9.58792C91.6709 10.0824 90.8192 10.3022 89.7203 10.3022H81.2588V19.6154H86.6984V14.5879H90.05C91.7808 14.5879 93.2918 14.3132 94.583 13.7363C95.8467 13.1593 96.8357 12.3352 97.55 11.2637C98.2368 10.2198 98.594 8.95605 98.594 7.5C98.594 6.07143 98.2368 4.8077 97.55 3.73627ZM114.791 13.5714C115.972 12.9945 116.906 12.1978 117.565 11.1538C118.225 10.1099 118.554 8.9011 118.554 7.5C118.554 6.07143 118.197 4.8077 117.51 3.73627C116.796 2.66484 115.807 1.84066 114.543 1.26374C113.252 0.686817 111.741 0.384619 110.01 0.384619H101.219V4.67033H109.681C110.78 4.67033 111.631 4.91759 112.208 5.41209C112.758 5.9066 113.06 6.62088 113.06 7.5C113.06 8.4066 112.758 9.09341 112.208 9.58792C111.631 10.0824 110.78 10.3022 109.681 10.3022H101.219V19.6154H106.659V14.5055H109.626L113.115 19.6154H118.939L114.791 13.5714Z"
                    fill="var(--color-sidebarmenulink-normal)"
                  />
                </svg>
                <p className="text-white text-center pt-3">v{config.version}</p>
              </div>
            </div>
            
          </nav>

        </div>
        {/* End Sidebar scroll*/}
      </aside>
    );
  }
}

function mapDispatchToProps(dispatch) {
  return {
    commonActions: bindActionCreators(actionCreators, dispatch),
    dispatch,
    getChargeCodes : bindActionCreators(getChargeCodes, dispatch)
  };
}

function mapStateToProps(state) {
  return {
    equipment: state.changeEquipemt,
    userType: state.HomeReducer.userType,
    requests: state.CarrierUnApprovedRequestReducer,
    isAuthorized: state.LoginReducer.authenticated,
    UnAssignedrequests: state.UnAssignedShipmentReducer,
    changeNav: state.changeNav,
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Sidebar);
